import React from 'react';
import DiamondModel from './DiamondModel';
import './HomePage.css';
import { useNavigate } from 'react-router-dom';

function Hero() {
  const navigate = useNavigate();

  return (
    <div className='hero-section'>
      <div className='animated-background'></div>
      <div className='hero-container'>
        <div className='content-wrapper'>
          <div className='model-container'>
            <div className='diamond-wrapper'>
              <DiamondModel />
              <div className='particle-overlay'></div>
            </div>
          </div>
          <div className='text-content'>
            <h1 className='futuristic-heading gradient-text'>NM&nbsp;Diamond</h1>
            <p className='subtitle shimmer'>Elegance In Every Detail</p>
            <p className='description'>NM DIAMONDS,brings you the finest diamond jewelry designed in the heart of Surat and Mumbai, delivered straight to your doorstep. Choose us for exclusive designs and unbeatable wholesale prices.</p>
            <button className='neon-button' onClick={() => navigate('/collections')}>
              <span className='button-content'>Explore Collection</span>
              <span className='neon-border'></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;